export enum TrackEventEnum {
  DEBT_ADDED = "DEBT_ADDED",
  DEBT_REMOVED = "DEBT_REMOVED",
  DEBT_UPDATED = "DEBT_UPDATED",
  EXPENSE_CATEGORY_ADDED = "EXPENSE_CATEGORY_ADDED",
  EXPENSE_CATEGORY_REMOVED = "EXPENSE_CATEGORY_REMOVED",
  EXPENSE_CATEGORY_UPDATED = "EXPENSE_CATEGORY_UPDATED",
  GOAL_ADDED = "GOAL_ADDED",
  GOAL_REMOVED = "GOAL_REMOVED",
  GOAL_UPDATED = "GOAL_UPDATED",
  INCOME_SOURCE_ADDED = "INCOME_SOURCE_ADDED",
  INCOME_SOURCE_REMOVED = "INCOME_SOURCE_REMOVED",
  INCOME_SOURCE_UPDATED = "INCOME_SOURCE_UPDATED",
  PRO_POPUP_SHOWN = "PRO_POPUP_SHOWN",
  PRO_POPUP_HIDDEN = "PRO_POPUP_HIDDEN",
  SAVING_ADDED = "SAVING_ADDED",
  SAVING_REMOVED = "SAVING_REMOVED",
  SAVING_UPDATED = "SAVING_UPDATED",
  STARTUP_POPUP_CLOSED = "STARTUP_POPUP_CLOSED",
  STARTUP_POPUP_SHOWN = "STARTUP_POPUP_SHOWN",
  TRANSACTION_ADDED = "TRANSACTION_ADDED",
  TRANSACTION_REMOVED = "TRANSACTION_REMOVED",
  TRANSACTION_UPDATED = "TRANSACTION_UPDATED",
}

export type TrackEventType =
  | TrackEventEnum.DEBT_ADDED
  | TrackEventEnum.DEBT_REMOVED
  | TrackEventEnum.DEBT_UPDATED
  | TrackEventEnum.EXPENSE_CATEGORY_ADDED
  | TrackEventEnum.EXPENSE_CATEGORY_REMOVED
  | TrackEventEnum.EXPENSE_CATEGORY_UPDATED
  | TrackEventEnum.GOAL_ADDED
  | TrackEventEnum.GOAL_REMOVED
  | TrackEventEnum.GOAL_UPDATED
  | TrackEventEnum.INCOME_SOURCE_ADDED
  | TrackEventEnum.INCOME_SOURCE_REMOVED
  | TrackEventEnum.INCOME_SOURCE_UPDATED
  | TrackEventEnum.PRO_POPUP_HIDDEN
  | TrackEventEnum.PRO_POPUP_SHOWN
  | TrackEventEnum.SAVING_ADDED
  | TrackEventEnum.SAVING_REMOVED
  | TrackEventEnum.SAVING_UPDATED
  | TrackEventEnum.STARTUP_POPUP_CLOSED
  | TrackEventEnum.STARTUP_POPUP_SHOWN
  | TrackEventEnum.TRANSACTION_ADDED
  | TrackEventEnum.TRANSACTION_REMOVED
  | TrackEventEnum.TRANSACTION_UPDATED;
